define("shared/components/shared/profile-categorization/categorize-steps/progress-bar", ["exports", "@ember/component", "@glimmer/component", "later/models/social-profile", "@ember/template-factory"], function (_exports, _component, _component2, _socialProfile, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"later/models/social-profile",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="tSC--avatar u--m__b__xs">
    <img class="tSC--avatar__img" src={{this.profileTypeImageUrl}} />
    <svg>
      <circle class="tSC--avatar__circle" cx="33" cy="33" r="30"></circle>
      <circle class={{concat "tSC--avatar__loader " this.progressClass}} cx="33" cy="33" r="30"></circle>
    </svg>
  </div>
  */
  {
    "id": "QpRWHnxM",
    "block": "[[[10,0],[14,0,\"tSC--avatar u--m__b__xs\"],[12],[1,\"\\n  \"],[10,\"img\"],[14,0,\"tSC--avatar__img\"],[15,\"src\",[30,0,[\"profileTypeImageUrl\"]]],[12],[13],[1,\"\\n  \"],[10,\"svg\"],[12],[1,\"\\n    \"],[10,\"circle\"],[14,0,\"tSC--avatar__circle\"],[14,\"cx\",\"33\"],[14,\"cy\",\"33\"],[14,\"r\",\"30\"],[12],[13],[1,\"\\n    \"],[10,\"circle\"],[15,0,[28,[37,0],[\"tSC--avatar__loader \",[30,0,[\"progressClass\"]]],null]],[14,\"cx\",\"33\"],[14,\"cy\",\"33\"],[14,\"r\",\"30\"],[12],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[],false,[\"concat\"]]",
    "moduleName": "shared/components/shared/profile-categorization/categorize-steps/progress-bar.hbs",
    "isStrictMode": false
  });
  class ProgressBarComponent extends _component2.default {
    get progressClass() {
      const value = Number(this.args.progressValue.toFixed(1)) * 10;
      return `tSC--avatar__loader${value}`;
    }
    get socialProfile() {
      return this.args.socialProfile;
    }
    get profileTypeImageUrl() {
      switch (this.socialProfile.instagramProfileType) {
        case _socialProfile.InstagramProfileTypes.Business:
          return '/assets/images/img--signUp--igBusiness.svg';
        case _socialProfile.InstagramProfileTypes.Creator:
          return '/assets/images/img--signUp--igCreator.svg';
        case _socialProfile.InstagramProfileTypes.Personal:
          return '/assets/images/img--signUp--igPersonal.svg';
        default:
          return '/assets/images/img--signUp--ig.svg';
      }
    }
  }
  _exports.default = ProgressBarComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ProgressBarComponent);
});